import { render, staticRenderFns } from "./TransferenciaContaCorrente.vue?vue&type=template&id=71059728"
import script from "./TransferenciaContaCorrente.vue?vue&type=script&lang=js"
export * from "./TransferenciaContaCorrente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports